/**
 * This file was automatically generated by `IconCodeGenerator`.
 * DO NOT MODIFY IT BY HAND. Instead, follow the instructions at `src/shared/joykit/packages/core/icons/README.md`.
 */

import * as React from 'react';

import createSvgIcon from '../createSvgIcon';

import { SvgIconConfig } from '../types';

const config: SvgIconConfig = {
  title: 'Chevron Left Rounded',
  definitions: {
    '24': {
      viewBox: '0 0 24 25',
      path: (
        <>
          <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M15.4331 4.49937C15.6849 4.69436 15.7104 5.03309 15.4901 5.25593L8.77088 12.0517L15.4901 18.8475C15.7104 19.0703 15.6849 19.409 15.4331 19.604C15.1813 19.799 14.7985 19.7764 14.5782 19.5536L7.50989 12.4048C7.31002 12.2026 7.31002 11.9008 7.50989 11.6986L14.5782 4.5498C14.7985 4.32695 15.1813 4.30437 15.4331 4.49937Z"
            fill="currentColor"
          />
        </>
      ),
    },
  },
};

const icon = createSvgIcon(config);
export default icon;
